export default __webpack_public_path__ + "static/media/PeopleHoldingHands.4ccc5d95.jpg";